/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getTopUpLedgerConfigFromProps } from '../helpers';
import type { MoonPayTopUpBalanceLedgerProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPayTopUpLedgerWidget(
  props: MoonPayTopUpBalanceLedgerProps,
) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getTopUpLedgerConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
